import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { usePathname } from "next/navigation";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";

const TopMenu = ({ top_menu }) => {
  const [showSubMenu, setShowSubMenu] = useState(null);
  const path = usePathname();

  return (
    <div className="flex flex-row gap-8">
      {top_menu?.map((item, idx) => {
        const { ID: main_id, title: itemTitle, url: itemUrl, slug: itemSlug, children } = item || {};
        const has_children = children && children.length > 0;
        const is_active = itemSlug === path;
        const has_active_child = children?.some(child => child.slug === path);

        return (
          <nav key={idx} className="w-fit top_menu">
            {has_children ? (
              <div className="relative">
                <div
                  className="inline-flex items-center gap-2 text-sm font-medium no-underline cursor-pointer"
                  onClick={() => {
                    setShowSubMenu(main_id);

                    if (showSubMenu === main_id) {
                      setShowSubMenu(null);
                    }
                  }}
                >
                  <span className={`text-dark-text ${is_active || has_active_child ? "border-b border-primary font-bold" : ""}`}>
                    {itemTitle}
                  </span>
                  {has_children && (<FontAwesomeIcon icon={faChevronDown} className="w-3 text-primary" />)}
                </div>


                <div className={`lg:absolute left-0 lg:pt-5 transition-all w-fit duration-300 ${main_id == showSubMenu ? "visible h-full" : "h-0 invisible pointer-events-none"}`}>
                  <div className={`flex flex-col lg:flex-row overflow-hidden bg-white lg:drop-shadow-3xl rounded-10 ease-in-out transition-all duration-300 max-w-screen w-full ${main_id == showSubMenu ? " translate-y-0 delay-75 visible opacity-1" : "invisible opacity-0 translate-y-1"}`}>
                    <ul className={`bg-white px-6 pt-4 lg:p-4 w-full`}>
                      {children?.map((child, idx) => {
                        const { ID: id_child, title, url, slug } = child || {};
                        const active_child = slug == path;

                        if (!title || !url) return;

                        return (
                          <div className="flex items-center w-full gap-2 mb-2 lg:mb-5 last:mb-0" key={"child_" + id_child}>
                            <li className="inline-block w-full">
                              <a
                                href={url}
                                title={title}
                                className={`${active_child ? "bg-active-background" : ""} hover:bg-active-background block transition-all duration-300 px-4 py-2 leading-6 text-dark-text text-sm text-nowrap no-underline rounded-5`}
                              >
                                {title}
                              </a>
                            </li>
                          </div>
                        )
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              <a
                href={itemUrl || "/"}
                className="inline-flex items-center gap-1 text-sm font-medium no-underline"
                title={itemTitle}
              >
                <span className={`text-dark-text ${is_active ? "border-b border-primary font-bold" : ""}`}>
                  {itemTitle}
                </span>
                {has_children && (<FontAwesomeIcon icon={faChevronDown} className="w-1 text-primary" />)}
              </a>
            )}
          </nav>
        );
      })}
    </div>
  );
};

export default TopMenu;
